import { defineStore } from 'pinia';
import { pathToName } from '@/utils/router.js';
import router from '@/core/router.js';

export function filterAsyncRoutes(asyncRouterMap) {
  const accessedRouters = asyncRouterMap.map((menuRoute) => {
    /* if (route.isStatus == '0') {
      return false;
    } */
    const { componentPath, permUrl, permName, icon, children } = menuRoute;
    const route = {
      path: permUrl,
      name: pathToName(permUrl),
      meta: {
        title: permName,
        icon,
        show: menuRoute.isStatus !== undefined ? menuRoute.isStatus == '1' : true,
      },
    };
    if (componentPath) {
      if (componentPath === 'Frame') {
        route.component = () => import('@/components/frame/index.vue');
      } else {
        route.component = () => import(`@/views/${componentPath}.vue`);
      }
    } else {
      route.component = () => import('@/components/frame/EmptyRouter.vue');
    }
    if (children && children.length) {
      route.children = filterAsyncRoutes(children);
    }
    // return true;
    return route;
  });
  return accessedRouters;
}

export default defineStore('menu', {
  state: () => {
    return {
      config: {
        activeTextColor: '#4B4B4B',
        // backgroundColor: "rgb(0 21 41)",
        // activeBackgroundColor: "#214e7c",
        // activeBackgroundColor: '#daebfe',
        router: true,
        collapse: false, //是否水平折叠收起菜单
        uniqueOpened: false, //是否只保持一个子菜单的展开
      },
      options: [],
      sideMenus: [],
      // options: [
      //   {
      //     title: '首页',
      //     name: 'home',
      //     icon: () => (
      //       <el-icon>
      //         <img src={icon_home} alt="" />
      //       </el-icon>
      //     ),
      //   },
      //   {
      //     title: '用户管理',
      //     name: 'user',
      //     icon: () => (
      //       <el-icon>
      //         <img src={icon_user} alt="" />
      //       </el-icon>
      //     ),
      //     children: [
      //       {
      //         title: '人员管理',
      //         name: 'personnel',
      //       },
      //       {
      //         title: '账号管理',
      //         name: 'account',
      //       },
      //       {
      //         title: '用户组管理',
      //         name: 'userGroup',
      //       },
      //     ],
      //   },
      //   {
      //     title: '角色管理',
      //     name: 'role',
      //     icon: () => (
      //       <el-icon>
      //         <img src={icon_role} alt="" />
      //       </el-icon>
      //     ),
      //   },
      //   {
      //     title: '组织管理',
      //     name: 'organization',
      //     icon: () => (
      //       <el-icon>
      //         <img src={icon_organization} alt="" />
      //       </el-icon>
      //     ),
      //     children: [
      //       {
      //         title: '组织设置',
      //         name: 'organizationSet',
      //       },
      //       {
      //         title: '部门设置',
      //         name: 'departmentSet',
      //       },
      //     ],
      //   },
      //   {
      //     title: '菜单管理',
      //     name: 'menu',
      //     icon: () => (
      //       <el-icon>
      //         <img src={icon_menu} alt="" />
      //       </el-icon>
      //     ),
      //   },
      //   {
      //     title: '系统设置',
      //     name: 'system',
      //     icon: () => (
      //       <el-icon>
      //         <img src={icon_system} alt="" />
      //       </el-icon>
      //     ),
      //     children: [
      //       {
      //         title: '日志查看',
      //         name: 'log',
      //       },
      //       // {
      //       //     title: "系统用户",
      //       //     name: "systemUser",
      //       // },
      //     ],
      //   },
      //   {
      //     title: '统计分析',
      //     name: 'analyes',
      //     icon: () => (
      //       <el-icon>
      //         <img src={icon_statistics} alt="" />
      //       </el-icon>
      //     ),
      //   },
      //   {
      //     title: '个人信息',
      //     name: 'personal',
      //     icon: () => (
      //       <el-icon>
      //         <img src={icon_personal} alt="" />
      //       </el-icon>
      //     ),
      //     children: [
      //       // {
      //       //     title: "我的应用",
      //       //     name: "application",
      //       // },
      //       {
      //         title: '修改密码',
      //         name: 'password',
      //       },
      //     ],
      //   },
      //   // {
      //   //     title: "授权管理",
      //   //     name: "empowerment",
      //   //     icon: () => (
      //   //         <el-icon>
      //   //             <HomeFilled />
      //   //         </el-icon>
      //   //     ),
      //   // },
      // ],
      include: [], //缓存页面 （页面组件的name）
      exclude: [], //剔除缓存页面 （页面组件的name）
      breadcrumb: [], //面包屑
      headerMenus: [], //头部菜单
    };
  },
  getters: {},
  actions: {
    generateRoutes(routes, constRoutes) {
      this.reset();
      this.options = [...routes];

      const accessedRoutes = filterAsyncRoutes(routes);

      this.addMenus(accessedRoutes, 'sideMenus');
      this.addMenus(constRoutes || [], 'sideMenus');
      return accessedRoutes;
    },
    setOptions(options) {
      this.options = options;
    },
    reset() {
      this.options = [];
      this.sideMenus = [];
    },
    addMenus(menus, type = 'sideMenus') {
      // this[type] = [...this[type], ...menus];
      // 动态添加路由
      menus.forEach((route) => {
        const show = route.meta.show !== undefined ? route.meta.show : true;
        route.meta.show = show;
        if (show) {
          this[type].push(route);
        }
        router.addRoute('home', route);
      });
    },
    setHeaderMenu(headerMenu) {
      this.resetHeaderMenu();
      this.addMenus(headerMenu, 'headerMenus');
    },
    resetHeaderMenu() {
      this.headerMenus = [];
    },
    // 缓存页面
    cacheMenu(currMenuPageName, remove = false) {
      if (!this.include.includes(currMenuPageName) && !remove) {
        this.include.push(currMenuPageName);
      } else if (this.include.includes(currMenuPageName) && remove) {
        this.include = this.include.filter((name) => name !== currMenuPageName);
      }
    },
    // 剔除缓存
    excludeMenu(currMenuPageName, remove = false) {
      if (!this.exclude.includes(currMenuPageName) && !remove) {
        this.exclude.push(currMenuPageName);
      } else if (this.exclude.includes(currMenuPageName) && remove) {
        this.exclude = this.exclude.filter((name) => name !== currMenuPageName);
      }
    },
  },
});
